import React, { useContext, useState } from 'react';
import * as S from './styled';
import Form from '../..';
import { ValidityContext } from '../../../../provider/ValidityProvider';

export default function FormStatusDelete() {
  const { setModal, getValidity, setValidity, deleteStatus } =
    useContext(ValidityContext)!.controllers.status;

  const [loading, setLoading] = useState(false);
  const selectedStatus = getValidity('selected.status');
  const selectedStatuses = getValidity('selecteds.status');
  const statusIds =
    selectedStatus !== null ? [selectedStatus] : selectedStatuses;
  const length = statusIds.length;

  const close = () => {
    setModal('single.deleteStatus', false);
    setValidity('selected.status', null);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    deleteStatus(statusIds)
      .then(() => {
        close();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <S.Form
      style={{
        maxHeight: '30vh',
      }}
      onSubmit={onSubmit}
    >
      <S.Body>
        <div style={{ marginLeft: '20px' }}>
          {length === 1
            ? 'Tem certeza que deseja excluir o status?'
            : `Tem certeza que deseja excluir ${length} status?`}
        </div>
      </S.Body>
      <S.Actions>
        <Form.Button type="button" onClick={close}>
          Fechar
        </Form.Button>
        <Form.Button loading={loading}>Excluir</Form.Button>
      </S.Actions>
    </S.Form>
  );
}
